import * as $ from 'jquery';
import autocomplete from 'autocompleter';

export class SolrSuggestController {

  constructor() {
    this.init();
  }

  protected init() {
    let self = this;
    let searchFormSelector = $('form[data-suggest]');
    searchFormSelector.each((index, searchForm) => {
      self.solrSuggest(searchForm);
    });
  }

  protected solrSuggest(searchForm) {
    let inputField = searchForm.querySelector('.tx-solr-suggest');
    let searchAjaxUrl = $(searchForm).data('suggest');
    let suggestions = [] as any;
    let suggestionCount = 5;

    if (inputField !== null) {
      autocomplete({
        input: inputField,
        minLength: 3,
        debounceWaitMs: 250,
        className: 'solr--autocomplete',
        fetch: function(text, update) {
          $.ajax({
            url: searchAjaxUrl,
            data: {tx_solr: {queryString: text}},
            dataType: 'jsonp',
            jsonp: 'tx_solr[callback]',
          }).done(function(response) {
            if (!response.suggestions) {
              update([]);
              return {suggestions: []};
            }
            suggestions = $.map(response.suggestions, function (count, suggestion) {
              if (suggestion !== text) {
                return {label: suggestion, value: suggestion};
              }
            });
            suggestions = suggestions.slice(0, suggestionCount);
            suggestions.unshift({label: text, value: text});
            update(suggestions);
          }).fail(function() {
            suggestions = [];
            update([]);
          });
        },
        onSelect: function(item) {
          inputField.value = item.label;
          $(searchForm).trigger('submit');
        }
      });
    }
  }

}
